
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cbq-ecr.cjs.production.min.js')
} else {
  module.exports = require('./cbq-ecr.cjs.development.js')
}
